import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Option } from '../interfaces';

export const STORAGE_TYPE = {
   INTERNAL: 'INTERNAL',
   EXTERNAL: 'EXTERNAL',
   COMMERCIAL_NETWORK: 'COMMERCIAL_NETWORK',
   CLIENT: 'CLIENT',
};

export const useStorageTypeLabels = () => {
   const { t } = useTranslation();

   return useMemo(() => {
      const STORAGE_TYPE_PL = {
         INTERNAL: t('storage_type_pl.internal'),
         EXTERNAL: t('storage_type_pl.external'),
      };

      const STORAGE_TYPE_LABELS: { [key: string]: string } = {
         INTERNAL: t('storage_type_labels.internal'),
         EXTERNAL: t('storage_type_labels.external'),
         COMMERCIAL_NETWORK: t('storage_type_labels.commercial_network'),
      };

      const STORAGE_TYPE_LABELS_SINGULAR: { [key: string]: string } = {
         INTERNAL: t('storage_point_type.internal_storage'),
         EXTERNAL: t('storage_point_type.external_storage'),
         COMMERCIAL_NETWORK: t('storage_type_labels_singular.commercial_network'),
      };

      const STORAGE_TYPES_FOR_PICKER: Option[] = [
         {
            label: STORAGE_TYPE_LABELS_SINGULAR[STORAGE_TYPE.INTERNAL],
            value: STORAGE_TYPE.INTERNAL,
         },
         {
            label: STORAGE_TYPE_LABELS_SINGULAR[STORAGE_TYPE.EXTERNAL],
            value: STORAGE_TYPE.EXTERNAL,
         },
         {
            label: STORAGE_TYPE_LABELS_SINGULAR[STORAGE_TYPE.COMMERCIAL_NETWORK],
            value: STORAGE_TYPE.COMMERCIAL_NETWORK,
         },
      ];

      const STORAGE_TYPES_FOR_ADMISSION_PICKER = [
         {
            label: STORAGE_TYPE_LABELS_SINGULAR[STORAGE_TYPE.INTERNAL],
            value: STORAGE_TYPE.INTERNAL,
         },
         {
            label: STORAGE_TYPE_LABELS_SINGULAR[STORAGE_TYPE.EXTERNAL],
            value: STORAGE_TYPE.EXTERNAL,
         },
      ];

      const STORAGE_TYPES_FOR_CLIENT_PICKER = [
         { label: t('storage_type_labels_singular.client'), value: STORAGE_TYPE.CLIENT },
      ];

      return {
         STORAGE_TYPE_PL,
         STORAGE_TYPE_LABELS,
         STORAGE_TYPE_LABELS_SINGULAR,
         STORAGE_TYPES_FOR_PICKER,
         STORAGE_TYPES_FOR_ADMISSION_PICKER,
         STORAGE_TYPES_FOR_CLIENT_PICKER,
      };
   }, [t]);
};
